import { API_URL } from './instances';

export class SseApi {
  openStream(emitterId: string): string {
    return `${API_URL}sse?emitterId=${emitterId}`;
  }
}
